module.exports = __webpack_public_path__ + "media/images/logo-1-12cca1e4ec740fccc47d01247362985f.png";